import httpClient from '@/lib/httpClient.js'
import { useQuery } from '@tanstack/react-query'
import useModelsFingerprint from '@/services/api/model/useModelsFingerprint'

/**
 * GET /team/cash-flow/forecast-score — serves both the Dashboard widget
 * (FE 9) and the cashflow table score row (FE 14).
 *
 * summary.average is computed server-side (the provisional-period exclusion
 * rule lives exactly once, there) — never re-derive it from the period list.
 */
export default function useGetForecastScore({
  offset,
  numberOfPeriods,
  periodType,
  summary = false,
  enabled = true,
} = {}) {
  const modelsFingerprint = useModelsFingerprint()

  const fetchData = async () => {
    const response = await httpClient.get('team/cash-flow/forecast-score', {
      params: {
        o: offset,
        c: numberOfPeriods,
        p: periodType,
        summary: summary ? 'true' : undefined,
      },
    })
    return response.data
  }

  return useQuery({
    queryKey: [
      'forecast-score',
      { offset, numberOfPeriods, periodType, summary, modelsFingerprint },
    ],
    queryFn: fetchData,
    staleTime: Infinity,
    enabled,
  })
}
